/* eslint-disable max-classes-per-file */
/* eslint-disable react/no-deprecated */
/* eslint-disable react/function-component-definition */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent } from '@formio/react';
import { Tooltip, TextInput } from '../../../canvasComponents/index';
import { FormattedMessage, IntlProvider, injectIntl } from 'react-intl';
import axios from 'axios';
import settingsForm from './CustomAutocompleteDMTI.settingsForm';
import './CustomAutocompleteDMTI.scss';
import { AddressModal } from '../utils/AddressModal/AddressModal';
import { addressValidation } from '../../../services/addressService';
import getLocalParams from '../localizationCustoms';
import FormioErrorHandler, { useErrorStatus } from '../../../components/FormioErrorHandler/FormioErrorPopup';

const withHooksHOC = (ChildComponent) => (props) => {
  const { setError } = useErrorStatus();
  return <ChildComponent setError={setError} {...props} />;
};
class CustomAutocompleteDMTI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      error: { found: false, message: '' },
      // The suggestions that match the user's input
      filteredSuggestions: [],
      // What the user has entered
      value: props.value === null ? { value: '', addressObj: {} } : props.value,
    };
    this.bearerToken = {
      token: null,
      expiresOn: null,
    };
    this.setShowModal = this.setShowModal.bind(this);
    this.setSubmitAddress = this.setSubmitAddress.bind(this);
    this.setError = props.setError;
  }

  componentDidMount() {
    this.getDmtiToken();
  }

  setShowModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

  setSubmitAddress = (address) => {
    const { props: { component: { useReviewLabel, reviewLabel, label }, onChange } } = this || null;
    let finalAddress = {};
    let concatenatedAddress = '';

    if (address.country === 'CA') {
      finalAddress = {
        street: address.street,
        streetName: address.streetName,
        city: address.city,
        country: address.country,
        provinceState: address.province,
        postalCode: address.postalCode,
      };

      concatenatedAddress = `${address.street} ${address.streetName} ${address.city} ${address.province} ${address.country} ${address.postalCode}`;
    } else {
      finalAddress = {
        street: address.street,
        streetName: address.streetName,
        city: address.city,
        country: address.country,
        provinceState: address.state,
        postalCode: address.zipCode,
      };
      concatenatedAddress = `${address.street} ${address.streetName} ${address.city} ${address.state} ${address.country} ${address.zipCode}`;
    }

    this.setState(
      (prevState) => (
        {
          showModal: !prevState.showModal,
          error: { found: false, message: '' },
          value: { value: concatenatedAddress,
            addressObj: finalAddress,
            review: { label: useReviewLabel ? reviewLabel : label } },
        }),
      () => {
        // eslint-disable-next-line react/destructuring-assignment
        onChange(this.state.value);
      },
    );
  };

  getDmtiToken = () => {
    axios
      .get('/dmti/token')
      .then((res) => {
        if (res.status === 200 && res.data.access_token) {
          const d = new Date();
          this.bearerToken.expiresOn = new Date(d.getTime() + res.data.expires_in * 1000);
          this.bearerToken.token = res.data.access_token;
        }
      }).catch((err) => {
        console.log(err);
      });
  };

  onChange = (currentValue) => {
    const { state: { value }, props: { onChange } } = this;

    this.setState(
      {
        value: { value: currentValue, addressObj: value?.addressObj },
      },
    );

    if (this.bearerToken.expiresOn.getTime() - (new Date()).getTime() < 10000) {
      this.getDmtiToken();
    }

    if (currentValue.length > 5 && (currentValue.length % 3) === 0) {
      axios
        .get(`/dmti/suggestions/${this.bearerToken.token}/${currentValue}`)
        .then((res) => {
          if (res.data.length > 0) {
            const filteredSuggestions = res.data.map(
              (result) => result.aliasSuggest,
            );

            this.setState(
              {
                filteredSuggestions,
                error: { found: false, message: '' },
              },
            );
          } else {
            this.setState(
              {
                filteredSuggestions: [],
                error: { found: true, message: 'no suggestions' },
              },
              () => {
                onChange({
                  value: '',
                  addressObj: {},
                  review: {},
                });
              },
            );
          }
        }).catch((error) => {
          if (error.code === 'ERR_NETWORK') {
            this.setError({
              type: 'CONNECTION_ERROR',
            });
          }
          this.setState(
            {
              filteredSuggestions: [],
              error: { found: true, message: 'error validating' },
            },
            () => {
              onChange({
                value: '',
                addressObj: {},
                review: {},
              });
            },
          );
        });
    }
  };

  onClick = async (selectedAddress) => {
    const { props: { component: { useReviewLabel, reviewLabel, label }, onChange } } = this;
    let addressObj = {};
    try {
      const address = await addressValidation(selectedAddress);
      if (address.addressValidation && address.addressValidation.addressValidationResult === 'true') {
        addressObj = {
          street: address.addressValidation.streetNumber,
          streetName: `${address.addressValidation.streetName}${address.addressValidation.streetType ? ` ${address.addressValidation.streetType}` : ''}${address.addressValidation.streetDirection ? ` ${address.addressValidation.streetDirection}` : ''}`,
          city: address.addressValidation.municipality,
          country: 'Canada',
          provinceState: address.addressValidation.province,
          postalCode: address.addressValidation.postalCode,
        };

        this.setState(
          {
            filteredSuggestions: [],
            error: { found: false, message: '' },
            value: {
              value: selectedAddress,
              addressObj,
              review: { label: useReviewLabel ? reviewLabel : label },
            },
          },
          () => {
            // eslint-disable-next-line react/destructuring-assignment
            onChange(this.state.value);
          },
        );
      } else {
        this.setState(
          {
            filteredSuggestions: [],
            error: { found: true, message: 'error validating' },
          },
          () => {
            onChange({
              value: '',
              addressObj,
              review: {},
            });
          },
        );
      }
    } catch (error) {
      this.setState(
        {
          filteredSuggestions: [],
          error: { found: true, message: 'error validating' },
        },
        () => {
          onChange({
            value: '',
            addressObj,
            review: {},
          });
        },
      );
    }
  };

  render() {
    const {
      onChange,
      onClick,
      state: { filteredSuggestions, value, error, showModal },
      props: { component: { placeholder, hideCustomLabel, label, tooltip }, disabled, localParams, intl },
    } = this;

    let suggestionsListComponent;
    let errorHandlingComponent;

    if (value && value.value.length > 5 && filteredSuggestions.length) {
      suggestionsListComponent = filteredSuggestions.map((suggestion) => ({
        value: suggestion,
        label: <span>{suggestion}</span>,
      }));
    } else if (value && value.value.length > 5) {
      errorHandlingComponent = (
        error.found && (error.message === 'error validating' || error.message === 'no suggestions') ? <p className="address-error-message"><FormattedMessage id="Uh oh! Looks like we're having trouble validating this address. Please" defaultMessage="Uh oh! Looks like we're having trouble validating this address. Please" /> <button type="button" onClick={this.setShowModal} className="addAddressBtnDMTI"> <FormattedMessage id="add address" defaultMessage="add address" /></button> <FormattedMessage id="manually to continue." defaultMessage="manually to continue." /></p> : null
      );
    }

    return (
      <div style={{ position: 'relative' }}>
        {!hideCustomLabel && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <label className="label-question">
              {label}
            </label>
            {tooltip !== '' && (
              <Tooltip id="autocompletedmti" primary>
                {tooltip}
              </Tooltip>
            )}
          </div>
        )}
        <TextInput
          searchable
          searchResults={suggestionsListComponent}
          minLengthForSearchResults={6}
          disabled={disabled}
          placeholder={placeholder ? intl.formatMessage({ id: placeholder, defaultValue: placeholder }) : ''}
          highlight
          primary
          onSelect={(selectedAddress) => onClick(selectedAddress)}
          onChange={(currentValue) => onChange(currentValue)}
          defaultValue={value?.value ? value.value : ''}
        />
        {errorHandlingComponent}
        <AddressModal
          type="DMTI"
          showModal={showModal}
          setShowModal={this.setShowModal}
          setSubmitAddressModal={this.setSubmitAddress}
          localParams={localParams}
        />
      </div>
    );
  }
}

const CustomAutocompleteDMTIWithIntl = withHooksHOC(injectIntl(CustomAutocompleteDMTI));

export default class AutocompleteDMTIComp extends ReactComponent {
  /**
   * This function tells the form builder about your component. It's name, icon and what group it should be in.
   *
   * @returns {{title: string, icon: string, group: string, documentation: string, weight: number, schema: *}}
   */
  static get builderInfo() {
    return {
      title: 'Custom Autocomplete DMTI',
      icon: 'terminal',
      group: 'basic',
      documentation: '',
      schema: AutocompleteDMTIComp.schema(),
    };
  }

  /**
   * This function is the default settings for the component. At a minimum you want to set the type to the registered
   * type of your component (i.e. when you call Components.setComponent('type', MyComponent) these types should match.
   *
   * @param sources
   * @returns {*}
   */
  static schema(...extend) {
    return ReactComponent.schema(
      {
        type: 'customautocompletedmti',
        hideLabel: false,
      },
      extend,
    );
  }

  /*
   * Defines the settingsForm when editing a component in the builder.
   */
  static editForm = settingsForm;

  /**
   * This function is called when the DIV has been rendered and added to the DOM. You can now instantiate the react component.
   *
   * @param DOMElement
   * #returns ReactInstance
   */
  attachReact(element) {
    let instance;
    const localParams = getLocalParams(this.i18next.language);

    ReactDOM.render(
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <FormioErrorHandler>
          <CustomAutocompleteDMTIWithIntl
            ref={(refer) => {
              instance = refer;
            }}
            disabled={this._disabled}
            component={this.component} // These are the component settings if you want to use them to render the component.
            value={this.dataValue || this.dataForSetting} // The starting value of the component.
            onChange={this.updateValue} // The onChange event to call when the value changes.
            localParams={localParams}
          />
        </FormioErrorHandler>
      </IntlProvider>,
      element,
      () => { (this.reactInstance = instance); },
    );
  }

  /**
   * Automatically detach any react components.
   *
   * @param element
   */
  // eslint-disable-next-line class-methods-use-this
  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
